module.exports = __webpack_public_path__ + "img/milestones-en.f69fa840.png";